export function getColumnNames(filters) {
    const flatFilter = flatten(filters);
    const columnNamesSet = new Set();
    flatFilter.forEach((filter) => {
        if ('column' in filter) {
            columnNamesSet.add(filter.column);
        }
    });
    return Array.from(columnNamesSet);
}
export function flatten(filter) {
    const flatFilter = [];
    filter.forEach((f) => {
        if ('filter' in f) {
            flatFilter.push(...flatten(f.filter));
        }
        else {
            flatFilter.push(f);
        }
    });
    return flatFilter;
}
